export const API_USAGE_TRACKER = '/api/v1/metrics';
